import React from 'react'
import { createRoot } from 'react-dom/client'
import type { VelaWidgetProps } from './components/VelaWidget'
import { VelaWidget } from './components/VelaWidget'
import type { VelaStore } from './store'

class VelaWidgetManager {
  private props: VelaWidgetProps
  private rootElement: HTMLDivElement

  constructor(props: VelaWidgetProps) {
    if (!props.container) {
      throw new Error('Container element is required')
    }

    this.props = props

    // Create a temporary div to render the React component
    // This div will be removed by the VelaWidget when it creates the shadow DOM
    this.rootElement = document.createElement('div')
    this.rootElement.className = 'vela-widget-container'
    props.container.appendChild(this.rootElement)

    this.render()
  }

  private render(): void {
    try {
      const element = React.createElement(VelaWidget, this.props)

      const root = createRoot(this.rootElement)
      root.render(element)
    } catch (error) {
      console.error('Error rendering VelaWidget:', error)
      throw error
    }
  }

  update(): void {
    // call this to update the state of the widget
  }
}

export default VelaWidgetManager

export type { VelaStore, VelaWidgetProps }
